import DependencyInjector from 'js-core/js/DependencyInjector';

export default new DependencyInjector();
